import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { renderTrustedMarkdown } from '~/functions/markdown';
import { useGetImpactGoalQuery, useInstantiateGhgReductionImpactMutation } from '~/types/types';
import { GHG_ESTIMATOR_CONCEPT_ID } from '~/constants/concepts';
export default defineComponent({
  props: {},
  setup: function setup() {
    var route = useRoute();
    var router = useRouter();
    var ventureId = computed(function () {
      return route.params.venture || '';
    });
    var _useGetImpactGoalQuer = useGetImpactGoalQuery({
        ventureId: computed(function () {
          return ventureId;
        }).value
      }),
      impactGoalResult = _useGetImpactGoalQuer.result,
      refetch = _useGetImpactGoalQuer.refetch;
    var impactGoal = computed(function () {
      var _impactGoalResult$val;
      return impactGoalResult === null || impactGoalResult === void 0 ? void 0 : (_impactGoalResult$val = impactGoalResult.value) === null || _impactGoalResult$val === void 0 ? void 0 : _impactGoalResult$val.getImpactGoal;
    });
    var QuantifyGhgReductionButtonDisabled = ref(false);
    var showIxMethodology = ref(false);
    var _useInstantiateGhgRed = useInstantiateGhgReductionImpactMutation(),
      instantiateGhg = _useInstantiateGhgRed.mutate;
    var handleInstantiateGhg = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _response$data, _updatedImpactGoal$im, response, updatedImpactGoal, ghgImpact, _ghgImpact$impactSolu, solutionPath, path;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!QuantifyGhgReductionButtonDisabled.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              QuantifyGhgReductionButtonDisabled.value = true;
              _context.prev = 3;
              _context.next = 6;
              return instantiateGhg({
                ventureId: ventureId.value
              });
            case 6:
              response = _context.sent;
              updatedImpactGoal = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.instantiateGhgReductionImpact) || impactGoal.value; // Preserve routing logic: if a GHG impact exists, jump to its solution path (existing behavior)
              ghgImpact = updatedImpactGoal === null || updatedImpactGoal === void 0 ? void 0 : (_updatedImpactGoal$im = updatedImpactGoal.impacts) === null || _updatedImpactGoal$im === void 0 ? void 0 : _updatedImpactGoal$im.find(function (i) {
                return i.conceptId === GHG_ESTIMATOR_CONCEPT_ID;
              });
              if (!ghgImpact) {
                _context.next = 15;
                break;
              }
              solutionPath = ((_ghgImpact$impactSolu = ghgImpact.impactSolutions) === null || _ghgImpact$impactSolu === void 0 ? void 0 : _ghgImpact$impactSolu.length) > 0 ? 'solutions/0/ghgSavingPotential' : 'solutions';
              path = "/".concat(ventureId.value, "/impact/edit/impacts/").concat(ghgImpact.id, "/").concat(solutionPath);
              _context.next = 14;
              return router.push(path);
            case 14:
              return _context.abrupt("return");
            case 15:
              _context.prev = 15;
              // If the mutation errored, re‑enable the button so the user can retry.
              QuantifyGhgReductionButtonDisabled.value = false;
              return _context.finish(15);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3,, 15, 18]]);
      }));
      return function handleInstantiateGhg() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      ventureId: ventureId,
      impactGoal: impactGoal,
      handleInstantiateGhg: handleInstantiateGhg,
      QuantifyGhgReductionButtonDisabled: QuantifyGhgReductionButtonDisabled,
      showIxMethodology: showIxMethodology
    };
  },
  methods: {
    renderTrustedMarkdown: renderTrustedMarkdown
  }
});